import { GoogleMapsContext, toLatLngLiteral, useMapsLibrary } from "@vis.gl/react-google-maps";
import React, { useContext, useEffect, useRef } from "react";
import { t } from "@lingui/macro";
import { withI18n } from "@lingui/react";
import { OnDemandContext } from "../context";
import "./PlacesSearch.css";
import sendEvent from "../../../functions/analytics";

export const PlacesSearch = withI18n()(function PlacesSearchPure({ i18n }) {
  const placesApi = useMapsLibrary("places");
  const map = useContext(GoogleMapsContext)?.map;
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const { resetTourGeography } = useContext(OnDemandContext);

  useEffect(() => {
    if (!placesApi || !inputRef.current || !map) return;

    const autocomplete = new placesApi.Autocomplete(inputRef.current, {
      strictBounds: false,
      bounds: map.getBounds(),
      fields: ["geometry"],
    });

    const boundsChangedListener = map.addListener("bounds_changed", () => {
      autocomplete.setBounds(map.getBounds());
    });

    const placeChangedListener = autocomplete.addListener("place_changed", () => {
      const { geometry } = autocomplete.getPlace();

      sendEvent("track", "search_result_click");

      if (geometry?.location) {
        map.setCenter(geometry.location);
        resetTourGeography(toLatLngLiteral(geometry.location));
      }
    });

    autocompleteRef.current = autocomplete;

    return () => {
      boundsChangedListener.remove();
      placeChangedListener.remove();
    };
  }, [placesApi, map, resetTourGeography]);

  useEffect(() => {
    return () => {
      autocompleteRef.current = null;
    };
  }, []);

  return (
    <div role="combobox" className="places-search">
      <input
        ref={inputRef}
        placeholder={i18n._(t`Enter a location`)}
        type="text"
        className="places-search__input"
        onFocus={() => {
          sendEvent("track", "search_input_focus");
        }}
      />
    </div>
  );
});
